module.exports = __webpack_public_path__ + "static/images/six.18bFns5.svg";